/**
 * Data Integrity Page
 *
 * Admin page for monitoring data integrity across all companies.
 * Styled to match the existing admin dark theme.
 *
 * @since 2025-12-16
 */

import React from 'react';
import { DataIntegrityDashboard } from '../components/monitoring/DataIntegrityDashboard';
import { ShieldCheck } from 'lucide-react';

const DataIntegrityPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900 p-6">
      {/* Header */}
      <div className="relative overflow-hidden rounded-2xl mb-6">
        <div className="absolute inset-0 bg-gradient-to-br from-violet-600 via-purple-600 to-fuchsia-600 opacity-90"></div>
        <div className="relative px-8 py-12">
          <div className="flex items-center gap-3 mb-3">
            <ShieldCheck className="w-10 h-10 text-white" />
            <h1 className="text-4xl font-bold text-white">Data Integrity</h1>
          </div>
          <p className="text-white opacity-80 text-lg">
            Monitor commission data health, detect anomalies, and ensure data accuracy across all companies
          </p>
        </div>
      </div>

      {/* Dashboard Content */}
      <DataIntegrityDashboard />
    </div>
  );
};

export default DataIntegrityPage;
